import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import PersonIcon from '@mui/icons-material/Person';
import ItemList from '../../component/ItemList/index';
import FooterBar from './../../component/FooterAtom/index'
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import SliderOne from './../../img/chana.jpg';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DialogAtom from './../../component/DialogAtom/index';
import firebase from "../../config/firebase/index";
import Dropdown from '../../component/DropdownAtom/index.jsx';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import data from '../data';
import ReactGA from 'react-ga';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';

const URL = "http://localhost:3000/";

const CreatePost_EditPost = () => {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');


    const [productName, setProductName] = React.useState("चना");
    const dealer = JSON.parse(localStorage.getItem("user"));
    const [products, setProducts] = useState([]);

    const dealerNumber = dealer[0].PhoneNo;
    const dealerName = dealer[0].Name;
    const dealerImage = dealer[0].img;


    const unit = ["kg", "क्विंटल", "टन"];
    const [place, setPlace] = React.useState("");
    const [quantity, setQuantity] = React.useState("");
    const [maxPrice, setMaxPrice] = React.useState("");
    const [minPrice, setMinPrice] = React.useState("");
    const [message, setMessagePrice] = React.useState("");
    const [quantityUnit, setQuantityUnit] = React.useState("");
    const [image, setImage] = React.useState("");

    const [isShow, setIsShow] = useState(false);
    const [datas, setDatas] = useState();

    const [deals1, setDeals1] = useState([]);

    const showData = () => {
        setIsShow(true);
    };

    useEffect(() => {
        setDatas(data);
        firebase.database().ref("Commodity").once("value", snapshot => {

            const commodityData = snapshot.val();

            const tempCommodities = [];
            for (const key in commodityData) {

                const commodityObj = {
                    id: key,
                    ...commodityData[key],
                };
                tempCommodities.push(commodityObj);
            }
            console.log("Commodities ",tempCommodities);
            setProducts(tempCommodities)

        });
    }, []);


    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num ;
    }

    const createdAt = () => {

        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }

    const productRef = firebase.database().ref('Commodity').on('value', products => {
        console.log("Products", products.val());
    });

    const handleProductName = (e) => {
        setProductName("चना");
    }

    const selProduct = (val) => {
        console.log("Selected Val :: ",val);
        setProductName(val);
    }

    const handleQuantity = (e) => {
        setQuantity(e.target.value);
    }

    const handleMaxPrice = (e) => {
        setMaxPrice(e.target.value);
    }

    const handleMinPrice = (e) => {
        setMinPrice(e.target.value);
    }

    const handleMessage = (e) => {
        setMessagePrice(e.target.value);
    }

    const handlePlace = (e) => {
        setPlace(e.target.value);
    }

    const handleImage = (e) => {
        setImage(e.target.value);
    }

    const newDealCreationCompleted = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }


    const createDeal = () => {
        try {
            const dealRef = firebase.database().ref('Product');
            const newRef = dealRef.push();
            const key = newRef.key();
            const shareLink = URL + "/mobileBrowser/" + key;

            const deal = {
                DealId: key,
                DealerNumber: dealerNumber,
                DealerName: dealerName,
                DealerImage: dealerImage,
                Message: message,
                Place: place,
                Quantity: quantity,
                QuantityUnit: quantityUnit,
                minPrice: minPrice,
                maxPrice: maxPrice,
                productName: productName,
                createdAt: createdAt(),
                isActive: true,
                shareLink: shareLink,
            };

            newRef.set(deal);
            console.log(shareLink);
            alert("Deal added");
        }
        catch (error) {
            console.log(error);
        }
    };



    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleMaxWidthChange = (event) => {
        setMaxWidth(event.target.value);
    };

    const handleFullWidthChange = (event) => {
        setFullWidth(event.target.checked);
    };

    return (
        <Grid p={2} className={classes.commonSectionBuild}>
            <NoFollowMeta />
            <Box className={classes.iconOverImage}>
                <img width="100%" src={SliderOne} alt="" />
                <CloseIcon className={classes.topIconImage} style={{ fill: 'white' }} />
                <Box className={classes.editCenter}>
                    <input type="file" className={classes.editIcon} name="profile" />
                    <AutoAwesomeMotionIcon className={classes.centerIconImage} />

                </Box>
                <CloseIcon className={classes.topIconImage} style={{ fill: 'white' }} />
            </Box>

            <Box>
                <Typography variant="OVERLINE">
                    वस्तु
                </Typography>
                {
                        (products && products.length>0) ? 
                        (<Dropdown  products={products}  selectedProduct={selProduct}/>) :
                        (<TextfieldAtom placeholder="चना" varient="h6" style={{ fontWeight: 600 }} onChange={() => {productRef();  handleProductName();}} />)
                    }
                
            </Box>

            

            <Box >
                <Typography variant="OVERLINE">स्थान के अनुसार कीमत </Typography>
                <Box className={classes.keematBox}>
                    <Box>
                        <Box className={`${classes.keematBox} ${classes.headerBrowser1}`}>
                            <Typography variant="body1">स्थान</Typography>
                            <CloseIcon />
                        </Box>
                        <TextfieldAtom style={{ fontWeight: 600, color: '#53252f' }} onChange={handlePlace} />
                    </Box>
                    <Box className={classes.contetnArrange}>
                        <Box mr={1}>
                            <Typography variant="body2">न्यूनतम</Typography>
                            <TextfieldAtom onChange={handleMinPrice} />
                        </Box>
                        <Box className={classes.toCenter}>
                            <Typography variant="h6">to</Typography>
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body2">ज्यादा से ज्यादा </Typography>
                            <TextfieldAtom className={classes.jyadaInputBlock} onChange={handleMaxPrice} />
                        </Box>
                    </Box>
                </Box>
            </Box>



            <Box>
              
                    <Box >
                        <Typography variant="OVERLINE">स्थान के अनुसार कीमत </Typography>
                        <Box className={classes.keematBox}>
                            <Box>
                                <Box className={`${classes.keematBox} ${classes.headerBrowser1}`}>
                                    <Typography variant="body1">स्थान</Typography>
                                    <CloseIcon />
                                </Box>
                                <TextfieldAtom style={{ fontWeight: 600, color: '#53252f' }} onChange={handlePlace} />
                            </Box>
                            <Box className={classes.contetnArrange}>
                                <Box mr={1}>
                                    <Typography variant="body2">न्यूनतम</Typography>
                                    <TextfieldAtom type="number" inputType="number" onChange={handleMinPrice} />
                                </Box>
                                <Box className={classes.toCenter}>
                                    <Typography variant="h6">to</Typography>
                                </Box>
                                <Box ml={1}>
                                    <Typography variant="body2">ज्यादा से ज्यादा </Typography>
                                    <TextfieldAtom type="number" inputType="number" className={classes.jyadaInputBlock} onChange={handleMaxPrice} />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
              

            </Box>



            <Box className={classes.headerBrowser2}>
                {/* <AddIcon className={classes.headerBrowser3} /> */}
                {/* <TextfieldAtom placeholder="ek aur sheher ki keemat jode" /> */}
                <ButtonAtom
                    startIcon={<AddIcon />}
                    name="एक और शहर की कीमत जोड़े "
                    cclass="kgQuinatalTon"
                    onClick={showData}
                />
            </Box>

            <Typography variant="caption">लौट साइज </Typography>

            <Box className={classes.headerBrowser1}>


                <Box>
                    <TextfieldAtom inputType="number" type="number" placeholder="1" onChange={handleQuantity} />
                </Box>



                <Box ml={3}>
                    <ButtonAtom mb={3} ml={3}
                        name=" kg   "
                        // cclass="common0Btn1"
                        onClick={() => setQuantityUnit(unit[0])}
                    />
                </Box>

                <Box ml={3}>
                    <ButtonAtom mb={3} ml={3}
                        name=" क्विंटल    "
                        // cclass="common0Btn1"
                        onClick={() => setQuantityUnit(unit[1])}
                    />
                </Box>

                <Box ml={3} >
                    <ButtonAtom mb={3} ml={3}
                        name=" टन   "
                        // cclass="common0Btn1"
                        onClick={() => setQuantityUnit(unit[2])}
                    />
                </Box>




            </Box>

            <Box>
                <Typography variant="h6">सन्देश</Typography>
                <TextfieldAtom onChange={handleMessage} />
            </Box>

            <Box mt={4}>
                <ButtonAtom mb={3}
                    startIcon={<WhatsAppIcon />}
                    name=" Share on whatsapp   "
                    cclass="whatsUpBtn"
                    onClick={ () => { createDeal(); newDealCreationCompleted( 'New Deal', 'Click', 'Share on WhatsApp');}}
                />
            </Box>



        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        alignItems: 'center',
        boxSizing: 'border-box',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '40%',
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto',
        padding: '0 15px',
        boxSizing: 'border-box',
    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',

    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    commonNameCenter: {
        alignItems: 'center',
        marginLeft: '180px',
        marginRight: '60px',
        size: '20px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'



    },
    keematBox: {
        background: '#eee',
        padding: 15,
        boxSizing: 'border-box',

    },
    contetnArrange: {
        // width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    centerIconImage: {
        position: 'absolute',
        left: '50%',
        top: '30%',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
    },
    iconOverImage: {
        position: 'relative',
    },
    topIconImage: {
        position: 'absolute !important',
        left: '90%',
        bottom: '79%',
        transform: 'translate(-50%, -50%)',
        fill: 'white',
        cursor: 'pointer',
    },
    toCenter: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        textSize: '60px'
    },
    jyadaInputBlock: {
        marginLeft: '20px',
        marginRight: '20px',
        width: '20%',
    },
    editCenter: {
        position: 'absolute',
        top: '50%',
        right: '13%',
    },
    editIcon: {
        opacity: 0,
    },
    boxAlign: {
        width: '100%',
        padding: '0 10px',
        fontSize: '15px',
        minWidth: 'inherit',
        lineHeight: '40px',

    }


}));

export default CreatePost_EditPost;